import { Button, Icon, theme } from '@dasa-health/components-react'
import React, { useState } from 'react'
import { SignUpModal } from 'redesign/components/molecules/SignUpModal'
import { MiscOutlineQuestioncircle } from '@dasa-health/icons'
import { ModalDataContainer } from '../style'

export const StayConnectedModalButton = () => {
    const [isOpen, setIsOpen] = useState(false)
    return (
        <>
            <div>
                <Button
                    borderRadius="pill"
                    data-current-service={'Login faseado'}
                    data-item-position="Login CPF"
                    data-item-text="Modal Permanecer conectado"
                    onClick={() => setIsOpen(true)}
                    size="compact"
                    sx={{ paddingLeft: 1 }}
                    type="button"
                    variant="tertiary"
                >
                    <Icon color={theme.colors.black} size={16}>
                        <MiscOutlineQuestioncircle />
                    </Icon>
                </Button>
            </div>
            {isOpen && (
                <ModalDataContainer>
                    <SignUpModal
                        setShowModal={() => {
                            setIsOpen(v => !v)
                        }}
                        showModal={isOpen}
                        stayConnected
                        title="Permanecer conectado"
                    >
                        <p>
                            Ao marcar esta opção, sua sessão de usuário fica conectada por 10 dias consecutivos após o último acesso.
                            Durante este período, você acessa facilmente todos os recursos da plataforma sem precisar fazer login
                            novamente.
                        </p>
                        <p>
                            Pra desativar esta função, desmarque a opção <strong>Permanecer conectado.</strong> E não se preocupe, isso
                            não afeta as etapas seguintes de navegação.
                        </p>
                    </SignUpModal>
                </ModalDataContainer>
            )}
        </>
    )
}
